/**
 * Generic event keys — new convention
 *
 * Add new reusable events to this section. Use stable, lowercase snake_case
 * API keys and configure a separate human-readable name in Optimizely.
 * Model page, placement, tenant, and product context as event properties
 * instead of creating more event keys.
 *
 * See docs/experiments/experiments-dashboard-usage.md#event-key-rule.
 */
export const EXPERIMENTS_TRACK_EVENT_ADD_TO_CART = 'add_to_cart'
export const EXPERIMENTS_TRACK_EVENT_LOGIN_PAGE_VIEW = 'login_page_view'
export const EXPERIMENTS_TRACK_EVENT_LOGIN_SUCCESS = 'login_success'
export const EXPERIMENTS_TRACK_EVENT_RECOMMENDATION_PRODUCT_CLICK =
  'recommendation_product_click'
export const EXPERIMENTS_TRACK_EVENT_RECOMMENDATION_SHOW_ALL_PRODUCTS_CLICK =
  'recommendation_show_all_products_click'
export const EXPERIMENTS_TRACK_EVENT_RECOMMENDATION_SHOW_MORE_PRODUCTS_CLICK =
  'recommendation_show_more_products_click'
export const EXPERIMENTS_TRACK_EVENT_RATEPAY_PAYMENT_BUTTON =
  'ratepay_payment_button'
export const EXPERIMENTS_TRACK_EVENT_REMOVE_FROM_CART = 'remove_from_cart'
export const EXPERIMENTS_TRACK_EVENT_SEARCH_ATTRIBUTED_PURCHASE =
  'search_attributed_purchase'
export const EXPERIMENTS_TRACK_EVENT_SEARCH_PRODUCT_CLICK =
  'search_product_click'
export const EXPERIMENTS_TRACK_EVENT_SEARCH_USED = 'search_used'
export const EXPERIMENTS_TRACK_EVENT_PACKAGE_FEE_MODAL =
  'package_fee_modal_open'

/** Two-step login V1 diagnostic event keys. */
export const EXPERIMENTS_TRACK_EVENT_LOGIN_EMAIL_FAILURE = 'login_email_failure'
export const EXPERIMENTS_TRACK_EVENT_LOGIN_EMAIL_SUBMIT = 'login_email_submit'
export const EXPERIMENTS_TRACK_EVENT_LOGIN_PASSWORD_FAILURE =
  'login_password_failure'
export const EXPERIMENTS_TRACK_EVENT_LOGIN_PASSWORD_PAGE_VIEW =
  'login_password_page_view'
export const EXPERIMENTS_TRACK_EVENT_LOGIN_PASSWORD_SUBMIT =
  'login_password_submit'
export const EXPERIMENTS_TRACK_EVENT_LOGIN_OTP_FAILURE = 'login_otp_failure'
export const EXPERIMENTS_TRACK_EVENT_LOGIN_OTP_PAGE_VIEW = 'login_otp_page_view'
export const EXPERIMENTS_TRACK_EVENT_LOGIN_OTP_SUBMIT = 'login_otp_submit'
export const EXPERIMENTS_TRACK_EVENT_LOGIN_SWITCH_TO_OTP = 'login_switch_to_otp'
export const EXPERIMENTS_TRACK_EVENT_LOGIN_SWITCH_TO_PASSWORD =
  'login_switch_to_password'

/**
 * Legacy event keys
 *
 * Keep existing values stable unless their Optimizely configuration is
 * migrated at the same time. Do not use their naming as the convention for
 * new events.
 */
export const EXPERIMENTS_TRACK_EVENT_ACCOUNT_OVERVIEW_DOWNLOAD_INVOICE = `Account Overview - Click on download invoice`
export const EXPERIMENTS_TRACK_EVENT_ACCOUNT_OVERVIEW_HELP_WITH_MY_ORDER = `Account Overview - Click on help with my order`
export const EXPERIMENTS_TRACK_EVENT_ACCOUNT_OVERVIEW_LAST_ORDER_DETAIL = `Account Overview - Click on last order detail`

export const EXPERIMENTS_TRACK_EVENT_ACCOUNT_OVERVIEW_LAST_ORDER_TRACKING = `Account Overview - Click on last order tracking`

export const EXPERIMENTS_TRACK_EVENT_ACCOUNT_OVERVIEW_VIEW_ALL_ORDERS = `Account Overview - Click on view all orders`
export const EXPERIMENTS_TRACK_EVENT_ACCOUNT_MY_DATA_LINK = `Account Overview - Click on my data section link`
export const EXPERIMENTS_TRACK_EVENT_ACCOUNT_SERVICES_LINK = `Account Overview - Click on services section link`
export const EXPERIMENTS_TRACK_EVENT_ACCOUNT_HELP_CENTRE_LINK = `Account Overview - Click on help centre section link`

export const EXPERIMENTS_TRACK_EVENT_ACCOUNT_VISITOR = `Account Overview unique visitor`
export const EXPERIMENTS_TRACK_EVENT_RECOMMENDATION_PRODUCT_CLICK_HOMEPAGE =
  'Recommendation product click - Homepage'
export const EXPERIMENTS_TRACK_EVENT_RECOMMENDATION_PRODUCT_CLICK_MY_ACCOUNT =
  'Recommendation product click - My Account'
export const EXPERIMENTS_TRACK_EVENT_A2C_TOP_PRODUCT_CLICK =
  'Click on product of a2c_top'
export const EXPERIMENTS_TRACK_EVENT_A2C_TOP_SPONSORED_PRODUCT_CLICK =
  'Click on sponsored product of a2c_top'
export const EXPERIMENTS_TRACK_EVENT_A2C_TOP_NAVIGATION_CLICK =
  'Click on navigation of a2c_top'
export const EXPERIMENTS_TRACK_EVENT_A2C_TOP_LINK_CLICK =
  'Click on link of a2c_top'

export const EXPERIMENTS_TRACK_EVENT_PDP_ADD_TO_CART_MP_PRODUCT =
  'PDP - Click add-2-cart MP Product'
export const EXPERIMENTS_TRACK_EVENT_PDP_ADD_TO_CART_MP_PRODUCT_WITH_SELLER_PROMOTIONS =
  'PDP - Click add-2-cart MP Product with seller promotions'
export const EXPERIMENTS_TRACK_EVENT_PDP_SHOW_SELLER_MODAL =
  'PDP - Click show seller modal'
export const EXPERIMENTS_TRACK_EVENT_PDP_ADD_TO_CART_CTA =
  'PDP - Click on add-2-cart CTA'
export const EXPERIMENTS_TRACK_EVENT_PDP_CART_DRAWER_GO_TO_CART =
  'PDP - Cart intermediate drawer - Click on go to cart'
export const EXPERIMENTS_TRACK_EVENT_CART_CHECKOUT_BUTTON =
  'Cart - Click on checkout button'
export const EXPERIMENTS_TRACK_EVENT_RX_ADD_TO_CART = 'RX PDP - Add To Cart'
export const EXPERIMENTS_TRACK_EVENT_REMOVE_BANNERS_TOP_BANNER =
  'Click Top Banner'
export const EXPERIMENTS_TRACK_EVENT_REMOVE_BANNERS_SUBNAVIGATION =
  'Click Subnavigation'
export const EXPERIMENTS_TRACK_EVENT_REMOVE_BANNERS_PDP_APP_INSTALL =
  'Click PDP App Install'
export const EXPERIMENTS_TRACK_EVENT_REMOVE_BANNERS_ERX = 'Click eRX Pop-Up'

export const EXPERIMENTS_TRACK_EVENT_SEARCH_SUGGEST_CLICK_ON_ANY_PRODUCT =
  'search_box_click_on_suggested_product'
export const EXPERIMENTS_TRACK_EVENT_SEARCH_SUGGEST_V1_CLICK_ON_SPONSORED_PRODUCT =
  'search_box_click_on_suggested_product_sponsored'
export const EXPERIMENTS_TRACK_EVENT_SEARCH_SUGGEST_V1_CLICK_ON_NON_SPONSORED_PRODUCT =
  'search_box_click_on_suggested_product_non_sponsored'
export const EXPERIMENTS_TRACK_EVENT_CLICK_ON_PRODUCT =
  'Click on product detail link'

export const EXPERIMENTS_TRACK_EVENT_NFC_LP_CTA_CLICK = 'NFC LP - CTA click'
